<div class="search-container">
  <span class="search-icon">
    <img ngSrc="assets/icons/search_icon.svg" alt="" height="11" width="11">
  </span>
  <input class="form-input" [(ngModel)]="_searchText" (ngModelChange)="onSearchTextChange($event)"
         [placeholder]="placeholder" />
</div>
